/**
 *
 * @class PanoramaSelection
 *
 * holder for the current / preferred selected panorama with its timeline and milepost hints
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      July 2022
 *
 */
export class PanoramaSelection {

  /** the subdivision name */
  public sub: string      = '';

  /** the timeline hint */
  public timeline: string = '';

  /** the milepost hint */
  public mile: number     = 0.0;

  /** standard constructor */
  public constructor (init?: Partial<PanoramaSelection>) {

    Object.assign(this, init);
  }

}
